module.exports = __webpack_public_path__ + "static/media/1.20_preview.59e2c18e.png";